<template>
  <footer
    align-v="end"
    class="mt-auto bg-morado-palido text-morado-intenso source-sans d-print-none"
  >
    <b-container>
      <b-row>
        <b-col
          cols="12"
          md="7"
          lg="8"
          order="1"
          order-md="0"
          class="small pt-3 text-center text-md-left text-morado-intenso"
        >
          <div>Ministerio de Educación de Chile</div>
          <a
            href="https://www.gob.cl"
            target="_blank"
            class="d-block font-weight-bold text-morado-intenso"
            >Gobierno de Chile</a
          >
          <div>Av. Libertador Bernardo O'Higgins 1371.</div>
          <div class="text-azul-claro">Versión {{ version }}</div>
        </b-col>

        <b-container
          class="col-12 col-md-5 col-lg-4 order-0 order-md-1 pt-2 text-right text-morado-intenso"
        >
          <b-col class="pt-3 text-center text-morado-intenso">
            Consultas al siguiente teléfono
          </b-col>
          <b-col class="text-center text-morado-intenso">
            <FontAwesomeIcon
              icon="phone"
              class="fa-2x mt-2 d-none d-lg-inline-block"
            />
            <span
              class="h2 d-none d-lg-inline-block ml-2 font-weight-bold text-morado-intenso"
              >600 600 2626</span
            >
            <FontAwesomeIcon
              icon="phone"
              class="d-inline-block d-lg-none h5 text-morado-intenso"
            />
            <a href="tel:6006002626" style="color: azul;">
              <span
                class="h4 d-inline-block d-lg-none ml-1 font-weight-bold text-morado-intenso"
                >600 600 2626</span
              >
            </a>
          </b-col>
        </b-container>
      </b-row>
      <b-col cols="12" class="mt-4 mt-md-2 p-0 text-center text-md-left">
        <img
          src="https://cdnsaemineduc.s3.us-east-1.amazonaws.com/img/logofooter.png"
          width="160"
          height="15"
          alt=""
        />
      </b-col>
    </b-container>
  </footer>
</template>
<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faPhone);
export default {
  components: {
    FontAwesomeIcon
  },
  data() {
    return {
      version: VERSION
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/wrapper/Footer.vue